import CommonResult from 'app/components/OrderPayment/Common/CommonResult';
import React from 'react';

const EbanxResult = () => {
  return <CommonResult />;
};

export default EbanxResult;
